import React from 'react';
import { Supplier } from 'types/supplier';
import SupplierItemModule from './SupplierItemModule';
import List from 'components/list/List';

type SupplierListModuleProps = {
  suppliers: Supplier[];
};

const SupplierListModule: React.FC<SupplierListModuleProps> = ({ suppliers }) => {
  return (
    <List>
      {suppliers.map(supplier => (
        <SupplierItemModule key={supplier.id} supplier={supplier} />
      ))}
    </List>
  );
};

export default SupplierListModule;
